import type { SpotCategory } from '../types/spot.js';

export interface CategoryDefinition {
  value: SpotCategory;
  label: string;
  icon: string;
  color: string;
}

export const CATEGORIES: CategoryDefinition[] = [
  { value: 'bike_shop', label: '自転車ショップ', icon: '🚲', color: '#90CAF9' },
  { value: 'gourmet_cafe', label: 'グルメ・カフェ', icon: '🍽️', color: '#BCAAA4' },
  { value: 'convenience', label: 'コンビニ', icon: '🏪', color: '#FFAB91' },
  { value: 'park_roadstation', label: '公園・道の駅', icon: '🌳', color: '#A5D6A7' },
  { value: 'photo_spot', label: 'フォトスポット', icon: '📸', color: '#CE93D8' },
  { value: 'onsen', label: '温泉・銭湯', icon: '♨️', color: '#EF9A9A' },
  { value: 'parking', label: '駐輪場', icon: '🅿️', color: '#B0BEC5' },
  { value: 'tourist_spot', label: '観光地', icon: '🗺️', color: '#FFE082' },
  { value: 'caution', label: '要注意', icon: '⚠️', color: '#FF8A65' },
  { value: 'other', label: 'その他', icon: '📍', color: '#E0E0E0' },
];

export const CATEGORY_MAP = new Map<SpotCategory, CategoryDefinition>(
  CATEGORIES.map((c) => [c.value, c])
);

// 旧カテゴリ値との後方互換ラベル
const LEGACY_CATEGORY_LABELS: Record<string, string> = {
  cafe: 'カフェ・休憩所',
  rest_area: '道の駅・SA',
  scenic_spot: '絶景・展望',
  water: '給水スポット',
  repair: '修理・空気入れ',
};

export function getCategoryLabel(category: SpotCategory): string {
  return CATEGORY_MAP.get(category)?.label ?? LEGACY_CATEGORY_LABELS[category] ?? category;
}
